import React, { useEffect, useState } from "react";

const SVGComponent = ({ url, className, style, onLoad }) => {
    const [svgContent, setSvgContent] = useState("");

    useEffect(() => {
        const fetchSVG = async (url) => {
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error('Network response was not ok');
                const data = await res.text();
                setSvgContent(data);
                onLoad();
            } catch (error) {
                console.error('Fetch SVG failed:', error);
            }
        };

        fetchSVG('/assets/img/logo.svg').catch(() => fetchSVG('/logo.svg'));
    }, [url, onLoad]);

    return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: svgContent }} />;
};

export default SVGComponent;